<template>
	<tbody>
	<tr :style="`z-index: ${amountBoxes - idx}; position: relative;`" :key="keyTask" v-for="(task, keyTask, idx) in tasks">
		<td>
			<div class="item">
				<div class="box">
					<svg-sprite width="24" height="25" icon-id="box"></svg-sprite>
					<span>box {{ keyTask }}</span>
				</div>
			</div>
		</td>
		<template v-for="(item, keyItem) in task">
			<planer-td
					v-for="(body, keyBody) in item" :key="body.id + keyItem"
					:treeStructure="{ keyTask, keyItem, keyBody, orderId: body.orderId }"
					:body="body"
					@updateStructure="onStructure"
					@updateStructureWidth="onStructureWidth"
					@updateStartDrop="onStartDrop"
					@updateLines="onLines"
					@updateEditWorkOrder="onEditWorkOrder"
					@updateDayOff="onDayOff"
			></planer-td>
		</template>
	</tr>
	</tbody>
</template>

<script>
// vuex
import { mapActions } from "vuex";
// components
import PlanerTd from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerTd/PlanerTd";
import LeaderLine from "leader-line-vue";

export default {
	name: "PlanerTasks",
	props: {
		tasks: Object,
		date: String
	},
	components: {
		PlanerTd,
	},
	watch: {
		tasks(val) {
			if (val) {
				this.onLinesRemove();
				this.$nextTick(() => {
					this.getExistArrowList();
					this.initPlaner();
				});
			}
		}
	},
	data: () => ({
		existArrowList: [],
		linesList: [],
		amountBoxes: 14
	}),
	methods: {
		...mapActions([ 'onPlanerTasksSave', 'onWidthSave', 'onClearPlanerData' ]),
		onStartDrop() {
			this.onLinesRemove();
		},
		onLines() {
			this.existArrowList = [];
			this.$nextTick(() => {
				this.getExistArrowList();
				this.initPlaner();
			});
		},
		onEditWorkOrder(values) {
			this.$emit('updateEditWorkOrder', values);
		},
		onDayOff(id) {
			this.$emit('updateDayOff', id);
		},
		async onStructure(obj) {
			await this.onPlanerTasksSave(obj);
		},
		async onStructureWidth(values) {
			await this.onWidthSave(values);
		},
		onLinesRemove() {
			this.linesList.forEach((item) => {
				item.remove();
			});
			this.linesList = [];
		},
		onWatchLines(elem, isScrollable) {
			const elemScrollable = document.querySelector(elem);
			elemScrollable.addEventListener('scroll', () => {
				this.linesList.forEach((item) => {
					item.position();
				});

				if (isScrollable) {
					const planerTable = document.querySelector('.planer');

					const scrollW = elemScrollable.scrollWidth;
					const elemW = planerTable.scrollWidth;
					const scrollL = elemScrollable.scrollLeft;
					const count = scrollW - scrollL;

					if (parseInt(elemW) === parseInt(count)) {
						this.$emit('updatePlanerTasks');
					}
				}
			});
		},
		getExistArrowList() {
			Object.keys(this.tasks).map(box => {
				Object.keys(this.tasks[box]).map(time => {
					Object.keys(this.tasks[box][time]).forEach(task => {
						const item = { ...this.tasks[box][time][task] };
						if (item.name) this.existArrowList.push(item);
					});
				});
			});
		},
		initPlaner() {
			if (this.existArrowList && this.existArrowList.length) {
				this.existArrowList.forEach(body => {
					const { connectIds, color, orderId } = body;
					if (connectIds && connectIds.length) {
						connectIds.forEach((id) => {
							const elemFrom = document.getElementById(orderId);
							const connectItem = document.getElementById(id);
							if (elemFrom && connectItem) {
								const line = LeaderLine.setLine(elemFrom, connectItem, { color, size: 2 });
								line.id = id;
								this.linesList.push(line);
							}
						});
					}
				});
			}
		},
		/// methods for set scroll on the middle line
		onScrollTo() {
			const elem = document.querySelector('.planerChart');
			const planerTable = document.querySelector('.planer');
			const scrollW = elem.scrollWidth;
			const elemW = planerTable.scrollWidth;
			const count = (scrollW - elemW) / 2;

			elem.scrollTo({ left: count });
		}
	},
	mounted() {
		this.onWatchLines('.woStatisticsScroll');
		this.onWatchLines('.planerChart', 1);

		this.$nextTick(() => {
			this.getExistArrowList();
			this.initPlaner();
		});

		this.amountBoxes = +Object.keys(this.tasks).pop();
	},
	destroyed() {
		this.onLinesRemove();
		this.onClearPlanerData();
	}
};
</script>

<style scoped lang="scss">
	@import "planerTasks";
</style>
